export default __webpack_public_path__ + "static/website-dfb40857347cbda15324683f98869283.jpg";